import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/esm/Table';
import { CGM_CODE_SET, Channel_CODE_SET, Section_CODE_SET } from '../../../config/CgmCodeSet';
import PaginationAnything from '../pagination/PaginationAnything';
import { TREND_DETAIL_AGE_GENDER_SET } from '../../../config/TrendDetailAgeGenderSet';

import './TableForReport.css'

const openInNewTab = (url) => {
  var win = window.open(url, "", '_blank');
  win.focus();
}

const arrayCompare = (arr1, arr2) => {
  for (let i = 0; i < arr1.length || i < arr2.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
    else {
      continue;
    }
  }
  return true;
}

const TrendVolumeTable = (props) => {
  const data = props.data;
  console.log(data)
  return (
    <Table responsive>
      <thead>
        <tr>
          <th>검색어</th>
          <th>날짜</th>
          {/* <th>PC</th>
          <th>MOBILE</th> */}
          <th>ALL</th>
        </tr>
      </thead>
      <tbody>
        {data.query.map((queryItem, index) => {
          return (
            <>
              {data.data.map((row, rowIndex) => (
                <tr>
                  {rowIndex == 0 ?
                    <td rowSpan={data.data.length}>
                      {queryItem}
                    </td>
                    : null}
                  <td>
                    {row.hasOwnProperty('end_date') ?
                      `${row.date} ~ ${row.end_date}`
                      : row.date}
                  </td>
                  {/* <td>
                    {row[`pc${index}`]}
                  </td>
                  <td>
                    {row[`mo${index}`]}
                  </td> */}
                  <td>
                    {row[`all${index}`]}
                  </td>
                </tr>
              ))}
            </>
          )

        })}
      </tbody>
    </Table>
  )
}

const TrendDetailTable = (props) => {
  const data = props.data;
  console.log(data)
  return (
    <Table responsive>
      <thead>
        <tr>
          <th>검색어</th>
          <th>날짜</th>
          {data.genderage.map((gaItem, gaIndex) => {
            return (
              <th key={gaIndex}>{TREND_DETAIL_AGE_GENDER_SET[gaItem]}</th>
            )
          })}
        </tr>
      </thead>
      <tbody>
        {data.query.map((queryItem, index) => {
          return (
            <React.Fragment key={index}>
              {data.data.map((row, rowIndex) => (
                <tr key={`${index}-${rowIndex}`}>
                  {rowIndex == 0 ?
                    <td rowSpan={data.data.length}>
                      {queryItem}
                    </td>
                    : null}
                  <td>
                    {row.hasOwnProperty('end_date') ?
                      `${row.date} ~ ${row.end_date}`
                      : row.date}
                  </td>
                  {data.genderage.map((gaItem, gaIndex) => {
                    return (
                      <td>
                        {row[`all${index}-${gaItem}`]}
                      </td>
                    )
                  })}
                </tr>
              ))}
            </React.Fragment>
          )
        })}
      </tbody>
    </Table>
  )
}

const TableForTrend = (props) => {
  switch (props.reportType) {
    case "volume": {
      return (
        <TrendVolumeTable data={props.data} />
      )
    }
    case "detail": {
      return (
        <TrendDetailTable data={props.data} />
      )
    }
    default:
      return null;
  }
}

export default TableForTrend;